<template>
  <div 
    v-if="active"
    id="calculation-name-modal" 
    :class="{'is-active': active}"
    class="ec-modal ec-calculation-name-modal"
    @click.self="closeModal" >
    <div class="ec-modal-main is-loading animated fadeIn blue-border">
      <a 
        href="#" 
        class="close-icon modal-close" 
        @click.prevent="closeModal"/>
      <div class="ec-modal-headline">{{ $t('modals.save_calculation.save_calculation_headline') }}</div>
      <div 
        class="ec-modal-text" 
        v-text="displayText" />
      <div class="ec-modal-form-wrapper">
        <input 
          v-model="name"
          type="text"
          class="ec-modal-input">
      </div>
      <div class="ec-modal-btn-wrapper"> 
        <button 
          id="ec-modal-variable-ok" 
          class="ec-modal-btn-ok btn is-blue btn-has-max-width" 
          @click.prevent="changeName">{{ $t('modals.save_calculation.save_calculation_button') }}</button>
      </div> 
      <div 
        v-show="loading" 
        class="ec-modal-loader"/>
    </div>
  </div>
</template>

<script>
import {isFunction} from 'lodash'
import Modal from './Modal.mixin.vue'

export default {
  mixins: [Modal],
  data: function() {
    return {
      name: null,
      loading: false,
      text: null,
      autocall: null
    }
  },
  created() {
    this.$event.$on('change-calculation-name', (payload) => {
      if(AuthCheck) {
        this.active = true
        this.$store.modalOpen = true

        if(payload && payload.text) {
          this.text = payload.text
        } else {
          this.text = null
        }

        if(payload && isFunction(payload.autocall)) {
          this.autocall = payload.autocall
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'calculationSaved',
        });

      } else {
        this.$event.$emit('login-first', 'autocall-change-calculation-name')
      }
    })

    if(this.$cookie.get('autocall-change-calculation-name') === '1') {
      this.$cookie.delete('autocall-change-calculation-name')
      this.$event.$emit('change-calculation-name')
    }

    this.name = this.$store.calculationName
  },
  methods: {
    changeName() {
      this.loading = true

      axios.post('/calculation/'+this.$store.publicId+'/rename', {
          name: this.name
      }).then(() => {
        this.$store.calculationName = this.name
        this.$event.$emit('calculation-name-changed')
        this.closeModal()
        this.loading = false

        if(isFunction(this.autocall)) {
          this.autocall()          
          this.autocall = null
        }
      }) 
    }
  },
  computed: {
    displayText: function() {
      if(this.text) {
        return this.text
      }

      return this.$t('modals.save_calculation.save_calculation_default_msg')
    }
  }
}
</script>